import OrderCell from '../services/OrderCell';
import { GaragePinRow } from '../../types/garagePins';

interface GaragePinRowItemProps {
  row: GaragePinRow;
  total: number;
  bookableGateOn: boolean;
  disabled: boolean;
  onMove: (targetPosition: number) => void;
  onRemove: () => void;
}

/** One pinned garage in the Garage ordering table (Spec 061 §5). */
export default function GaragePinRowItem({ row, total, bookableGateOn, disabled, onMove, onRemove }: GaragePinRowItemProps) {
  return (
    <tr>
      <td>
        <OrderCell position={row.position} total={total} disabled={disabled} onMove={onMove} />
      </td>
      <td>
        <div style={{ fontWeight: 500 }}>{row.name}</div>
        {row.city && <div className="admin-text-muted" style={{ fontSize: '0.75rem' }}>{row.city}</div>}
      </td>
      <td>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.375rem' }}>
          {!row.visible && (
            <span className="admin-badge rejected" title="Not APPROVED or blocked — skipped in the app">Not visible</span>
          )}
          {row.serviceless && (
            <span className="admin-badge warning">
              No bookable service{bookableGateOn ? ' (hidden while the bookable-only gate is on)' : ''}
            </span>
          )}
          {row.visible && !row.serviceless && <span className="admin-text-muted">—</span>}
        </div>
      </td>
      <td>
        {row.setAt ? (
          <>
            <div>{row.setBy ?? 'unknown'}</div>
            <div className="admin-text-muted" style={{ fontSize: '0.75rem' }}>{formatWhen(row.setAt)}</div>
          </>
        ) : (
          <span className="admin-text-muted">— after save</span>
        )}
      </td>
      <td>
        <button type="button" className="admin-btn admin-btn-outline admin-btn-sm" disabled={disabled} onClick={onRemove}>
          Remove
        </button>
      </td>
    </tr>
  );
}

function formatWhen(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}
